<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import MarkdownContent from '@/components/docs/MarkdownContent.vue'
import AppLayout from '@/layouts/AppLayout.vue'
import { useAgreement } from '@/composables/useAgreement'

const route = useRoute()
const router = useRouter()
const confirmed = ref(false)
const { agreement, loading, error, refresh, accept } = useAgreement()

async function recordAcceptance() {
  try {
    await accept()
    const redirect = typeof route.query.redirect === 'string' && route.query.redirect.startsWith('/') ? route.query.redirect : '/'
    await router.replace(redirect)
  } catch {
    // The composable exposes a user-facing error state.
  }
}

onMounted(async () => {
  try { await refresh() } catch { /* The page displays the error state. */ }
})
</script>

<template>
  <AppLayout>
    <header class="page-heading agreement-heading">
      <p class="eyebrow">PORTAL AGREEMENT</p>
      <h1>Before you continue</h1>
      <p>Review and accept the agreement for your assigned portal role. This acceptance is recorded with your account.</p>
    </header>

    <p v-if="error" class="error">{{ error }}</p>
    <section v-else-if="agreement" class="agreement-card panel">
      <div class="agreement-meta"><span class="role-badge">{{ agreement.policy.role }}</span><small>Version {{ agreement.policy.version }}</small></div>
      <h2>{{ agreement.policy.title }}</h2>
      <p v-if="agreement.accepted" class="notice">Accepted {{ agreement.acceptance?.acceptedAt ? new Date(agreement.acceptance.acceptedAt).toLocaleString() : '' }}.</p>
      <MarkdownContent :markdown="agreement.policy.markdown" />
      <template v-if="!agreement.accepted">
        <label class="agreement-confirmation"><input v-model="confirmed" type="checkbox"> <span>I have read and agree to this portal agreement.</span></label>
        <button class="button primary" :disabled="loading || !confirmed" @click="recordAcceptance">{{ loading ? 'Recording agreement…' : 'Accept agreement' }}</button>
      </template>
    </section>
    <p v-else-if="loading" class="muted">Loading your agreement…</p>
  </AppLayout>
</template>
